import React, { useCallback } from 'react';
import { getIn18Text } from 'api';
import { Menu, Dropdown } from 'antd';
import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import { apiHolder as api, apis } from 'api';
import './index.scss';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const SEARCH_TYPES = {
    all: { key: 'all', name: getIn18Text('QUANBUJIEGUO') },
    title: { key: 'title', name: getIn18Text('ZHUTI') },
    sender: { key: 'sender', name: getIn18Text('FAJIANREN') },
    receiver: { key: 'receiver', name: getIn18Text('SHOUJIANREN') },
    attachment: { key: 'attachment', name: getIn18Text('FUJIANMINGCHENG') },
};
const SEARCH_TYPES_OPTIONS = Object.keys(SEARCH_TYPES).map(key => SEARCH_TYPES[key]);
const BaseSearchFilter = ({ searchWord, searchType, setSearchType, onSearchChange, isSd = false }) => {
    const onItemSearchClick = useCallback((item) => {
        setSearchType(item.key);
        onSearchChange(searchWord);
        if (!isSd) {
            trackApi.track('pcMail_select_leftOptions_mailSearchResultPage', {
                searchRange: SEARCH_TYPES[searchType].name,
            });
        }
    }, [searchWord]);
    const DropdownOverlay = (React.createElement(Menu, { defaultSelectedKeys: [SEARCH_TYPES.all.key], selectedKeys: [searchType], className: "base-search-filter-menu" }, SEARCH_TYPES_OPTIONS.map(it => (React.createElement(Menu.Item, { key: it.key, onClick: () => onItemSearchClick(it) }, it.name)))));
    return (React.createElement(Dropdown, { overlay: DropdownOverlay, trigger: ['click'], placement: "bottomRight" },
        React.createElement("div", { className: "base-search-filter", style: { height: 26, lineHeight: '26px' } },
            React.createElement("span", { className: "search-filter-label", style: { marginLeft: 8 } }, getIn18Text('BAOHANSOUSUOCI')),
            React.createElement("div", { className: "search-filter-trigger" },
                React.createElement("span", { className: "search-filter-name" }, SEARCH_TYPES[searchType].name),
                React.createElement(CaretDownOutlined, { style: { color: '#386EE7', marginRight: 8 }, className: "dark-invert search-filter-icon" })))));
};
export default BaseSearchFilter;
